import { render, staticRenderFns } from "./r-product-page.vue?vue&type=template&id=4616eca3"
import script from "./r-product-page.vue?vue&type=script&lang=js"
export * from "./r-product-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4616eca3')) {
      api.createRecord('4616eca3', component.options)
    } else {
      api.reload('4616eca3', component.options)
    }
    module.hot.accept("./r-product-page.vue?vue&type=template&id=4616eca3", function () {
      api.rerender('4616eca3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/product/r-product-page.vue"
export default component.exports